import { configureStore } from "@reduxjs/toolkit";
import { saveTableState } from "./tables local storage";

// Slicers
import tablesSlicer from "./slicers/Tables Slicer";
import tutorialsSlicer from "./slicers/Tutorials Slicer";
import connectedDevicesSlicer from "./slicers/page specific slicers/Connected Devices Slicer";
import mappingAliasSlicer from "./slicers/page specific slicers/Mapping Alias Slicer";
import userInfoSlicer from "./slicers/User Info Slicer";
import adminPanelSlicer from "./slicers/page specific slicers/Admin Panel Slicer";
import OVSBotPipelineSlicer from "./slicers/page specific slicers/DRS Lists Pipeline Slicer";
import aliasRulesConstructorSlicer from "./slicers/page specific slicers/Alias Rules Constructor Slicer";
import generalSlicer from "./slicers/General Slicer";
import apiKeysSlicer from "./slicers/page specific slicers/API Keys Slicer";

// Middlewares
import { urlSearchParamsMiddleware } from "./middlewares/url search params";

// APIs
import { uiremoteApi } from "./api/uiremote api";
import { authApi } from "./api/auth api";
import { modelsApi } from "./api/models api";
import { aliasesApi } from "./api/aliases api";
import { googleAuthApi } from "./api/google auth api";
import { drsListsApi } from "./api/drs lists api";
import { dashboardApi } from "./api/dashboard api";
import { aliasesConstructorApi } from "./api/aliases constructor api";
import { userSettingsApi } from "./api/user settings api";
import { apiKeysApi } from "./api/api keys api";

export const store = configureStore({
  reducer: {
    [uiremoteApi.reducerPath]: uiremoteApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [modelsApi.reducerPath]: modelsApi.reducer,
    [aliasesApi.reducerPath]: aliasesApi.reducer,
    [googleAuthApi.reducerPath]: googleAuthApi.reducer,
    [drsListsApi.reducerPath]: drsListsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [aliasesConstructorApi.reducerPath]: aliasesConstructorApi.reducer,
    [userSettingsApi.reducerPath]: userSettingsApi.reducer,
    [apiKeysApi.reducerPath]: apiKeysApi.reducer,
    general: generalSlicer,
    tables: tablesSlicer,
    tutorials: tutorialsSlicer,
    connectedDevices: connectedDevicesSlicer,
    mappingAlias: mappingAliasSlicer,
    userInfo: userInfoSlicer,
    adminPanel: adminPanelSlicer,
    ovsBotPipeline: OVSBotPipelineSlicer,
    aliasRulesConstructor: aliasRulesConstructorSlicer,
    apiKeys: apiKeysSlicer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(uiremoteApi.middleware)
      .concat(authApi.middleware)
      .concat(modelsApi.middleware)
      .concat(aliasesApi.middleware)
      .concat(googleAuthApi.middleware)
      .concat(drsListsApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(aliasesConstructorApi.middleware)
      .concat(userSettingsApi.middleware)
      .concat(apiKeysApi.middleware)
      .concat(urlSearchParamsMiddleware),
});

store.subscribe(() => {
  const state = store.getState().tables;
  Object.keys(state).forEach((tableId) => {
    saveTableState(tableId, state[tableId]);
  });
});
